/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import ViewDocForm from "../components/ViewDocForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

function ViewDocumentPage() {
  const { i18n } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const [savedLanguage, setSaveLanguage] = useState();

  useEffect(() => {
    setSaveLanguage(i18n.language);
  }, [i18n.language]);

  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:w-deflaut md:flex">
        <div className="w-full">
          <Button onClick={() => navigate(-1)} className="cursor-pointer">
            <p className="text-header text-ft-light hover:text-ft font-bold">
              {savedLanguage === "en"
                ? location.state.event.titleEng
                : savedLanguage === "cn"
                  ? location.state.event.titleCn
                  : location.state.event.titleHk}
            </p>
          </Button>
          <ViewDocForm
            documentCenterList={
              location.state !== null ? location.state.event : ""
            }
          />
        </div>
      </div>
    </div>
  );
}

export default ViewDocumentPage;
